// Environment configuration utility

const getEnvironmentConfig = () => {
  const env = process.env.REACT_APP_ENV || 'development';
  
  // Default configuration
  const defaultConfig = {
    logoUrl: '/header-logo.png', // Jobotics AI logo from public folder
    welcomeInfo: 'Welcome to Jobotics AI',
    environment: env
  };

  // Environment-specific overrides
  const environmentConfigs = {
    development: {
      logoUrl: process.env.REACT_APP_LOGO_URL || defaultConfig.logoUrl,
      welcomeInfo: process.env.REACT_APP_WELCOME_INFO || defaultConfig.welcomeInfo,
    },
    demo: {
      logoUrl: process.env.REACT_APP_LOGO_URL || defaultConfig.logoUrl,
      welcomeInfo: process.env.REACT_APP_WELCOME_INFO || 'Welcome to Jobotics Copilot',
    },
    production: {
      logoUrl: process.env.REACT_APP_LOGO_URL || defaultConfig.logoUrl,
      welcomeInfo: process.env.REACT_APP_WELCOME_INFO || defaultConfig.welcomeInfo,
    }
  };

  const config = {
    ...defaultConfig,
    ...environmentConfigs[env]
  };

  // Debug logging for development
  if (env === 'development') {
    console.log('Environment Config:', {
      env,
      logoUrl: config.logoUrl,
      welcomeInfo: config.welcomeInfo,
      rawEnvVars: {
        REACT_APP_ENV: process.env.REACT_APP_ENV,
        REACT_APP_LOGO_URL: process.env.REACT_APP_LOGO_URL,
        REACT_APP_WELCOME_INFO: process.env.REACT_APP_WELCOME_INFO
      }
    });
  }

  return config;
};

export default getEnvironmentConfig;
